export const faqs = [
  {
    q: "投稿需要注册账号吗？会不会要求我留下真实身份？",
    a: "不需要注册，也不会要求你提供真实姓名、身份证号或手机号。投稿表单里的联系方式一栏是可选的，你留不留、留什么，由你决定。如果后续编辑需要补充材料，会通过你主动留下的方式联系你。",
  },
  {
    q: "匿名投稿之后，我的身份真的不会被认出来吗？",
    a: "我们在流程上做了两层隔离：投稿内容与提交记录分开存储，原始材料只有值班编辑可以查看。发布前，所有可能指向个人的信息——姓名、工号、车牌、聊天头像——都会统一处理。到目前为止，我们的投稿人身份泄露记录为零。",
  },
  {
    q: "我手上只有一段聊天记录，材料不完整，可以投吗？",
    a: "可以。线索的价值不在于长短，而在于真实。哪怕只是一句“我知道某件事”，也值得投。编辑会先判断它是否具备核查方向，再告诉你要不要补充其他材料。",
  },
  {
    q: "投稿之后多久会有回复？",
    a: "正常情况下 3 个工作日内给出初步反馈。如果线索涉及的领域比较专业，核查时间会相应拉长。我们没有回复，通常意味着这条线索还在排队，而不是被忽略。",
  },
  {
    q: "什么样的内容你们不会采用？",
    a: "三类内容我们不处理：一是无法核实来源的传言；二是包含他人隐私且与公共利益无关的材料；三是明显出于商业竞争或个人恩怨的举报。这几类即使投过来，编辑也只能作归档处理。",
  },
  {
    q: "我不想让自己的材料被完全公开，可以只提供给编辑核查吗？",
    a: "可以。你可以在投稿时注明“仅供核查，不建议公开”。我们会尊重这个选择，把它作为核查参考，而不是直接发布。",
  },
  {
    q: "如果我发现你们发布的内容有错误，怎么办？",
    a: "请通过联系我们页面的表单或编辑邮箱反馈，注明具体的文章与段落。我们核实后会更正，并在文末公开说明修改内容，而不会悄悄删掉。",
  },
  {
    q: "你们靠什么维持运营？会不会收钱办事？",
    a: "平台不接受任何以“发布”或“撤稿”为前提的付费。我们只接受读者自愿的内容支持，并且所有支持者与线索处理流程完全隔离。如果发现编辑存在有偿删稿行为，欢迎举报。",
  },
];